import styled from 'styled-components';
import Image from '@stencil/image';

export const CancelList_Wrap = styled.ul(
  props => `
    display:flex;
    flex-direction:column;
    li{
    display:flex;
    margin-bottom:${props.theme.spacing.custom(21)};
    flex-direction: revert;
    align-items: baseline;
    }
      `,
);

export const SuperStarImg = styled(Image)(
  props => `
    width: 9.5rem;
    height: 2.5rem;
    margin-right: ${props.theme.spacing.base};
    `,
);

export const Left_wrap = styled.div(
  props => `
    width:10px;
    height:10px;
    border-radius:50%;
    background:black;
    flex-shrink: 0;
    margin-right:10px;
    `,
);

export const Text_Head = styled.p(
  props => `
     font-size: ${props.theme.font.custom(16)};
     font-weight: 600;
     margin-bottom:${props.theme.spacing.custom(2)};

      `,
);

export const Sub_Text_Head = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:${props.theme.colors.downriver.medium};
    width:77%;
     
      `,
);

export const Superstar_tag = styled.p(
  props => `
    background-color:#fdf6e9;
    color:#ad6620;
    font-weight: 600;
    font-size: ${props.theme.font.custom(16)};
    width:fit-content;
    padding: ${props.theme.spacing.small};
    border-radius:25px;
    margin-bottom:${props.theme.spacing.small};
    display:flex;
    `,
);

export const Superstar_OuterWrap = styled.p(
  props => `
    display:flex;
    align-items: baseline;
    `,
);
